import React, { Component } from "react";
import { searchIcon } from "../../../utils/images";
import commonContext, { AppContext } from "../../../context/common";
import { leadType } from "../../../../app";

interface IProps {
    list?: Array<object>;
    errorText: string;
    title: string;
    name: string;
    handlerOnChange?: Function;
    value?: any;
}
interface IState {
    showListClass: string;
    dropDown: Array<object>;
    list: Array<object>;
}
interface IDealer {
    suppId?: string;
    supplierDesc?: string;
    address1?: string;
    address2?: string;
    address3?: string;
    address4?: string;
}

class SelectDropDownForm extends Component<IProps, IState> {
    static contextType = commonContext;
    lead: leadType;
    setLead: Function;
    leadError: any;
    setLeadError: Function;
    constructor(props: IProps) {
        super(props);
        this.state = {
            showListClass: "hidden",
            dropDown: [],
            list: [],
        };
    }
    showListHandler(): void {
        this.lead = (this.context as AppContext).lead as leadType;
        this.setLead = (this.context as AppContext).setLead;
        this.setLeadError = (this.context as AppContext).setLeadError;
        this.setState({
            showListClass: "",
            list: this.lead.dealers,
            dropDown: this.lead.dealers ? this.lead.dealers : [],
        });
    }
    hideListHandler(): void {
        setTimeout(() => {
            this.setState({ showListClass: "hidden" });
        }, 300);
    }
    searchHandler(e: any): void {
        let filterDropDown = this.state.list.filter((dealer: IDealer) => {
            let address = `${dealer.address1} ${dealer.address2}`;
            address = dealer.address3
                ? address + " " + dealer.address3
                : address;
            address = dealer.address4
                ? address + " " + dealer.address4
                : address;
            if (
                dealer.supplierDesc.match(new RegExp(e.target.value, "i")) ||
                address.match(new RegExp(e.target.value, "i"))
            ) {
                return true;
            }
            return false;
        });
        this.setState({
            dropDown: filterDropDown,
        });
        this.setLead({
            dealerSupplierId: "",
            suppId: "",
            dealerName: e.target.value,
        });
        this.setLeadError({ dealerSupplierId: "Please Select Valid Dealer." });
    }
    selectDealerHandler(dealer: any): void {
        const dealerAddress = `${dealer.address1} ${dealer.address2} ${
            dealer.address3 ? dealer.address3 : ""
        } ${dealer.address4 ? dealer.address4 : ""}`;
        this.setLead({
            dealerSupplierId: dealer.suppId,
            dealerAddress: dealerAddress,
            dealerName: dealer.supplierDesc,
        });
        this.setLeadError({ dealerSupplierId: "" });
    }
    render() {
        this.lead = (this.context as AppContext).lead as leadType;
        this.leadError = (this.context as AppContext).leadError;
        return (
            <>
                <label className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base text-gray-500 ">
                    {this.props.title}
                </label>
                <input
                    autoComplete="off"
                    type="text"
                    onFocus={() => this.showListHandler()}
                    onBlur={() => this.hideListHandler()}
                    onChange={(e) => this.searchHandler(e)}
                    name={this.props.name}
                    value={this.lead.dealerName}
                    className="mt-1 mb-4 sm:mb-4 md:mb-6 lg:mb-6 xl:mb-6 focus:ring-gray-500 focus:border-gray-500 block w-full text-base md:text-base lg:text-lg xl:text-xl border-gray-300 border-b-2 border-gray-200 pr-8"
                />
                <button className="bg-transparent w-auto flex justify-end items-center absolute dearler-search-icon">
                    <img src={searchIcon} alt="" title="" />
                </button>
                <div
                    className={`vehicle-dealer-search w-full bg-white shadow-md px-4 py-4 relative sm:absolute z-10 top-0 sm:top-14 md:top-16 ${this.state.showListClass}`}
                >
                    <ul className="w-full">
                        {this.state.dropDown.map(
                            (dealer: IDealer, index: number) => (
                                <>
                                    <li
                                        onClick={() =>
                                            this.selectDealerHandler(dealer)
                                        }
                                        key={index}
                                        className="mb-4 pb-4 border-b vehicle-dealer-list-border"
                                    >
                                        <p className="openSans-SemiBold text-base sm:text-lg vehicle-dealer-name">
                                            {dealer.supplierDesc}
                                        </p>
                                        <p className="openSans-Reg text-xs sm:text-sm vehicle-dealer-add">
                                            {dealer.address1} {dealer.address2}{" "}
                                            {dealer.address3
                                                ? dealer.address3
                                                : ""}{" "}
                                            {dealer.address4
                                                ? dealer.address4
                                                : ""}
                                        </p>
                                    </li>
                                </>
                            )
                        )}
                    </ul>
                </div>
                {this.leadError["dealerSupplierId"] ? (
                    <span className="error-msg text-red-600 openSans-Reg text-xs md:text-sm lg:text-sm xl:text-sm">
                        {this.leadError["dealerSupplierId"]}
                    </span>
                ) : (
                    ""
                )}
            </>
        );
    }
}

export default SelectDropDownForm;
